import { Avatar, Tooltip } from "@mantine/core"

type UserAvatarProps = {
  fullName: string
  avatar?: string | null
  size?: string
}

export default function UserAvatar({
  fullName,
  avatar,
  size = "sm",
}: UserAvatarProps) {
  return (
    <Tooltip label={fullName}>
      <Avatar
        key={fullName}
        src={avatar || undefined}
        name={fullName}
        color="initials"
        size={size}
      />
    </Tooltip>
  )
}
